import { useTranslation } from 'react-i18next';
import OInput from '../../../UI/FormControls/OInput';
import TextArea from '../../../UI/FormControls/TextArea';
import CheckBox from '../../../UI/FormControls/CheckBox';
import AutocompleteMulti from '../../../UI/AutocompleteMulti';
import OAutocomplete from '../../../UI/MuiAutocomplete';
import useHttp from '../../../../hooks/use-http';
import { useEffect } from 'react';

const Inputs = ({
  formValues,
  setFormValues,
  tipMasineData,
  idKlijenta,
  klijent,
  jeInmold,
  menijiData,
}) => {
  const { t, i18n } = useTranslation();
  const { sendRequest: getZaposleni, data: zaposleniData } = useHttp('');

  useEffect(() => {
    getZaposleni({ url: 'Zaposleni/vrati_zaposlene' });
  }, []);

  const handleChange = (item) => {
    if (typeof formValues[item.target.name] === 'boolean') {
      setFormValues((curr) => {
        return { ...curr, [item.target.name]: item.target.checked };
      });
    } else {
      setFormValues((curr) => {
        return { ...curr, [item.target.name]: item.target.value };
      });
    }
  };
  // const handleAutocompleteChange = (event) => {
  //   const { id, vrednost } = event;
  //   setFormValues((prevData) => ({
  //     ...prevData,
  //     idKupca: id,
  //     nazivKupca: vrednost,
  //   }));
  // };
  const handleClickTip = (e) => {
    setFormValues((curr) => {
      return { ...curr, lista: e };
    });
  };

  const handleClickZaposleni = (item) => {
    console.log(item);
    setFormValues((curr) => {
      return {
        ...curr,
        idZaposlenog: item.id,
        imeZaposlenog: item.vrednost || '',
        ime: item.ime || '',
        prezime: item.prezime || '',
        email: item.email || '',
      };
    });
  };

  const handleClickMeni = (item) => {
    setFormValues((curr) => {
      return { ...curr, idMenija: item.id };
    });
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        flexGrow: '1',
      }}
    >
      <div
        style={{
          display: 'flex',
          gap: '15px',
          flexWrap: 'wrap',
        }}
      >
        <OInput
          label={`${t('firstName')} *`}
          name="ime"
          value={formValues.ime}
          handleChange={handleChange}
          touched={formValues.touchedIme}
          setTouched={() => {
            setFormValues((curr) => {
              return { ...curr, touchedIme: true };
            });
          }}
          errorMessage={`${t('firstName')} ${t('isRequired')}`}
          // style={{ width: '100%' }}
        />
        <OInput
          label={`${t('lastName')} *`}
          name="prezime"
          value={formValues.prezime}
          handleChange={handleChange}
          touched={formValues.touchedPrezime}
          setTouched={() => {
            setFormValues((curr) => {
              return { ...curr, touchedPrezime: true };
            });
          }}
          errorMessage={`${t('lastName')} ${t('isRequired')}`}
          // style={{ width: '100%' }}
        />
        <OInput
          label={`${t('userName')} *`}
          name="korisnickoIme"
          value={formValues.korisnickoIme}
          handleChange={handleChange}
          touched={formValues.touchedKorisnickoIme}
          setTouched={() => {
            setFormValues((curr) => {
              return { ...curr, touchedKorisnickoIme: true };
            });
          }}
          errorMessage={`${t('userName')} ${t('isRequired')}`}
          // style={{ width: '100%' }}
        />
        <OInput
          label={`${t('password')} *`}
          name="lozinka"
          value={formValues.lozinka}
          handleChange={handleChange}
          touched={formValues.touchedLozinka}
          setTouched={() => {
            setFormValues((curr) => {
              return { ...curr, touchedLozinka: true };
            });
          }}
          errorMessage={`${t('password')} ${t('isRequired')}`}
          // style={{ width: '100%' }}
        />
        <OInput
          label="Email"
          name="email"
          value={formValues.email}
          handleChange={handleChange}
          touched={formValues.touchedEmail}
          setTouched={() => {
            setFormValues((curr) => {
              return { ...curr, touchedEmail: true };
            });
          }}
          errorMessage={`Email ${t('isRequired')}`}
          style={{ width: '400px' }}

          // style={{ width: '100%' }}
        />
        {+localStorage.idFirme === 1 && klijent === '' && (
          <OAutocomplete
            data={zaposleniData}
            value={formValues.imeZaposlenog}
            handleClick={handleClickZaposleni}
            label={t('menuItem.Zaposleni')}
            style={{ maxWidth: '500px', width: '300px' }}
          />
        )}
        {jeInmold && (
          <OAutocomplete
            data={menijiData}
            value={
              menijiData.find((meni) => meni.id === formValues.idMenija)
                ?.vrednost || ''
            }
            handleClick={handleClickMeni}
            label={`${t('meni')} *`}
            touched={formValues.touchedMeni}
            setTouched={() => {
              setFormValues((curr) => {
                return { ...curr, touchedMeni: true };
              });
            }}
            errorMessage={t('meniObavezan')}
            style={{ maxWidth: '500px', width: '300px' }}
          />
        )}
        <AutocompleteMulti
          options={tipMasineData}
          value={formValues.lista || formValues.listaTipovaMasine}
          textProperty="vrednost"
          onChange={handleClickTip}
          text={t('responsibility')}
          style={{ maxWidth: '500px', width: '300px' }}
        />
        <OInput
          label={`${t('telephoneNumber')} *`}
          name="kontaktTelefon"
          value={formValues.kontaktTelefon}
          handleChange={handleChange}
          touched={formValues.touchedKontaktTelefon}
          setTouched={() => {
            setFormValues((curr) => {
              return { ...curr, touchedKontaktTelefon: true };
            });
          }}
          errorMessage={`${t('telephoneNumber')} ${t('isRequired')}`}
          // style={{ width: '100%' }}
        />

        {/* <OAutocomplete
          label="Firma"
          data={korisniciData}
          value={formValues.nazivKupca}
          style={{ width: '300px', cursor: 'pointer' }}
          handleClick={handleAutocompleteChange}
        /> */}
      </div>
      <div style={{ display: 'flex', gap: '2px', flexWrap: 'wrap' }}>
        <TextArea
          label={`${t('note')} *`}
          rows="4"
          name="napomena"
          value={formValues.napomena}
          handleChange={handleChange}
          style={{ width: '99%', height: '60px' }}
        />
        <CheckBox
          style={{ height: '70px' }}
          label={`${t('technicalPerson')} *`}
          handleChange={handleChange}
          checked={formValues.tehnickoLice}
          name="tehnickoLice"
        />
        <CheckBox
          style={{ height: '70px' }}
          label={`${t('adminisistrator')} *`}
          handleChange={handleChange}
          checked={formValues.administrator}
          name="administrator"
        />
        {!idKlijenta && (
          <CheckBox
            style={{ height: '70px' }}
            label={`${t('contactPerson')} *`}
            handleChange={handleChange}
            checked={formValues.kontaktOsoba}
            name="kontaktOsoba"
          />
        )}
        <CheckBox
          // style={{ height: '70px' }}
          label={`${t('ucestvujeUChatu')}`}
          handleChange={handleChange}
          checked={formValues.ucestvujeUChatu}
          name="ucestvujeUChatu"
        />{' '}
      </div>
    </div>
  );
};

export default Inputs;
